import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "./VolExp.scss";
import GSSOC from "../../assets/images/experience-page/39153675.png";
import SWOC from "../../assets/images/experience-page/1602422883512.jpg";
import CODE from "../../assets/images/experience-page/maxresdefault.jpg";

function VolExp() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const volunteerExperiences = [
        {
            id: 1,
            logo: GSSOC,
            programName: "GSSOC",
            fullName: "GirlScript Summer of Code",
            role: "Project Admin",
            season: "Summer 2022",
            description: "Led and managed open source projects, mentored contributors, and facilitated community growth in one of India's largest open source programs."
        },
        {
            id: 2,
            logo: SWOC,
            programName: "SWoC",
            fullName: "Script Winter of Code",
            role: "Project Admin",
            season: "Winter 2021",
            description: "Administered winter coding program, coordinated with mentors and participants, and ensured smooth project execution and community engagement."
        },
        {
            id: 3,
            logo: CODE,
            programName: "CodePeak",
            fullName: "CodePeak Open Source",
            role: "Mentor",
            season: "Winter 2022",
            description: "Mentored students in open source development, reviewed code contributions, and guided participants through their first open source experiences."
        }
    ];

    return (
        <Container fluid className="volunteer-experience-section" id="volunteer">
            <Container>
                <Row>
                    <Col xs={12}>
                        <div className="section-header text-center">
                            <h2 className="section-title">Volunteer Experience</h2>
                            <p className="section-subtitle">Contributing to open source communities and mentoring programs</p>
                        </div>
                    </Col>
                </Row>
                
                <Row className="g-4">
                    {volunteerExperiences.map((experience, index) => (
                        <Col key={experience.id} lg={4} md={6} sm={12} className="volunteer-col">
                            <Card className={`volunteer-card ${isVisible ? 'fade-in' : ''}`} 
                                  style={{ animationDelay: `${index * 0.2}s` }}>
                                <Card.Body className="card-content">
                                    {/* Logo Section */}
                                    <div className="logo-section">
                                        <div className="program-logo">
                                            <img 
                                                src={experience.logo} 
                                                alt={experience.programName} 
                                                className="logo-image"
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* Content Section */}
                                    <div className="content-section">
                                        <h3 className="program-name">{experience.programName}</h3>
                                        <h4 className="full-name">{experience.fullName}</h4>
                                        <div className="role-badge">
                                            <span className="role-text">{experience.role}</span>
                                        </div>
                                        <div className="season-info">
                                            <i className="fas fa-calendar-alt"></i>
                                            <span>{experience.season}</span>
                                        </div>
                                        <p className="description">{experience.description}</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    );
}

export default VolExp;
